import { combineReducers } from 'redux';
import lists from './lists.js';

export default combineReducers({lists});